var icon = require('vue-svgicon')
icon.register({
  'logo': {
    width: 16,
    height: 16,
    viewBox: '0 0 941.8 324.5',
    data: '<path pid="0" d="M70 315H11.6V97.1h58v12.2c20-11.6 37.2-17.4 51.4-17.4 23.5 0 41.7 6.8 54.5 20.5 26.7-13.6 51.1-20.5 73.2-20.5 28.8 0 48.7 8.4 59.9 25.1 11.2 16.7 16.8 43.4 16.8 80v118H267V198.6c0-18.6-2-32.3-6.1-41.2-4.1-8.9-12.2-13.3-24.4-13.3-9.3 0-20.6 2-34 6.1l-6.5 2.2c1.2 21.8 1.7 38.4 1.7 49.7V315h-58.4V203c0-21.5-1.9-36.7-5.7-45.5-3.8-8.9-12.1-13.3-24.8-13.3-11.3 0-22.5 2-33.6 6.1L70 152v163zM392.5 315V97.1h58.4V315h-58.4zM518.5 315V9.9h58.4V315h-58.4zM702.9 315h-58.4V9.9h58.4v173.5l22.2-3.9 43.2-82.4h65.4L777 200.4 836.7 315h-65.8l-44-85-24 3.9V315zM930.2 60.6c0 15.9-12.9 28.8-28.8 28.8s-28.8-12.9-28.8-28.8c0-22.5 28.8-51.2 28.8-51.2s28.8 28.7 28.8 51.2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/logo.js